export enum UserTypeId {
    INTERNAL = 1,
    EXTERNAL = 2,
    INTERNAL_API = 3,
    EXTERNAL_API = 4,
}

export enum UserType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
    INTERNAL_API = 'INTERNAL_API_USER',
    EXTERNAL_API = 'EXTERNAL_API_USER',
}
